const filterMenuData = (
  menuData = [],
  filterValue = '',
  isMultiNavData = false
) => {
  if (!Array.isArray(menuData) || menuData.length === 0 || !filterValue) {
    return menuData;
  }

  return menuData?.filter(item =>
    isMultiNavData ? item?.includedInMenus?.includes(filterValue) : true
  );
};

export default filterMenuData;
